// Class announcements: "HYROX starts in 15 minutes in the Astro. See you there!"
// The gym's approved timetable comes from the music service (Ads panel). At each
// gap between songs the player asks whether a class is coming up; if one is due
// it plays straight away, ahead of any ad. Times are the gym's local time, which
// is the clock of the computer the player runs on.

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] // Date#getDay order
const LATEST_BEFORE_START_MS = 2 * 60 * 1000 // too close to the start: skip it
const PLAYED_KEY = 'gr-class-announcements-played'

const dateKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

export function startOf (cls, now) {
  const [h, m] = String(cls.time || '').split(':').map((n) => parseInt(n, 10))
  if (isNaN(h) || isNaN(m)) return null
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m, 0, 0)
  return d
}

// The class whose announcement is due now (not yet played), if any.
export function dueClass (config, now, played = {}) {
  if (!config || !config.enabled || !config.approved) return null
  const lead = (Number(config.lead) || 15) * 60 * 1000
  const today = DAYS[now.getDay()]
  let best = null
  for (const cls of config.classes || []) {
    if (cls.day !== today || !cls.clipUrl) continue
    const start = startOf(cls, now)
    if (!start) continue
    const from = start.getTime() - lead
    const until = start.getTime() - LATEST_BEFORE_START_MS
    const key = `${dateKey(now)}-${cls.id}`
    if (now.getTime() >= from && now.getTime() < until && !played[key]) {
      if (!best || start < best.start) best = { cls, start, key }
    }
  }
  return best
}

export class ClassAnnouncer {
  config = null
  played = {}

  constructor () {
    try {
      const saved = JSON.parse(window.localStorage.getItem(PLAYED_KEY) || '{}')
      const today = dateKey(new Date())
      // keep today's only
      Object.keys(saved).forEach((k) => { if (k.startsWith(today)) this.played[k] = true })
    } catch (e) { /* storage unavailable: memory only */ }
  }

  setConfig (config) {
    this.config = config
  }

  // A track to play now, or null. Marks it as played.
  next (now = new Date()) {
    const due = dueClass(this.config, now, this.played)
    if (!due) return null
    this.played[due.key] = true
    try { window.localStorage.setItem(PLAYED_KEY, JSON.stringify(this.played)) } catch (e) { /* ignore */ }
    const { cls } = due
    return {
      uuid: `class-${cls.id}`,
      type: 'promotion',
      viewType: 'classannouncement',
      artist: 'Class announcement',
      title: `${cls.name} at ${cls.time}${cls.room ? ` · ${cls.room}` : ''}`,
      url: cls.clipUrl,
      gaiaId: ''
    }
  }

  // The next announcement still to play today, for the Ads panel.
  upcoming (now = new Date()) {
    if (!this.config || !this.config.enabled || !this.config.approved) return null
    const lead = (Number(this.config.lead) || 15) * 60 * 1000
    const today = DAYS[now.getDay()]
    let best = null
    for (const cls of this.config.classes || []) {
      if (cls.day !== today) continue
      const start = startOf(cls, now)
      if (!start || start.getTime() - LATEST_BEFORE_START_MS <= now.getTime()) continue
      if (this.played[`${dateKey(now)}-${cls.id}`]) continue
      if (!best || start < best.start) best = { cls, start, at: new Date(start.getTime() - lead) }
    }
    return best
  }
}
